import { openSlots, slotFor } from '@shared/eventTickets'
import type { EventTicketsView } from '../../../hooks/useEventTickets'

/** Whether the section shows anything beyond its entry row — drives where the party page places it. */
export function ticketsHaveContent({ mine, others }: EventTicketsView, viewerId: string, canEdit: boolean): boolean {
  if ((mine?.tickets ?? []).length > 0) return true
  if (others.some(l => slotFor(l, viewerId)?.accepted)) return true
  if (!canEdit) return false
  return !!mine?.seeking || others.some(l => !!l.seeking || !!slotFor(l, viewerId) || openSlots(l).length > 0)
}
